"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _unsafeCharRegex = _interopRequireDefault(require("../constants/unsafeCharRegex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TextArea = /*#__PURE__*/function (_React$Component) {
  _inherits(TextArea, _React$Component);

  var _super = _createSuper(TextArea);

  function TextArea(props) {
    var _this;

    _classCallCheck(this, TextArea);

    _this = _super.call(this, props);
    _this.onValueChange = _this.onValueChange.bind(_assertThisInitialized(_this));
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TextArea, [{
    key: "testRegex",
    value: function testRegex(val) {
      var pattern = _unsafeCharRegex["default"];
      var regex = new RegExp(pattern);
      var test = regex.test(val);
      return test;
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(e) {
      var val = e.target.value;

      if (this.testRegex(val)) {
        e.preventDefault();
      } else {
        this.props.onChange(val);
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(e) {
      var key = e.key;

      if (this.testRegex(key)) {
        e.preventDefault();
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var val = e.target.value;
      this.props.onBlur(val);
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var val = e.target.value;
      this.props.onFocus(val);
    }
  }, {
    key: "render",
    value: function render() {
      var successState = null;

      if (this.props.isValid !== null && this.props.isValid !== undefined) {
        if (this.props.isValid) {
          successState = "is-valid";
        } else {
          successState = "is-invalid";
        }
      }

      var className = "";

      if (!this.props.staticLabel) {
        className = "animated-placeholder ";
      }

      if (this.props.className) {
        className += this.props.className;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, this.props.staticLabel && /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: this.props.id
      }, this.props.label), /*#__PURE__*/_react["default"].createElement("textarea", {
        id: this.props.id,
        className: successState ? "form-control " + successState : "form-control",
        value: this.props.value,
        onChange: this.onValueChange,
        onKeyPress: this.onKeyPress,
        required: this.props.required,
        maxLength: this.props.maxLength ? this.props.maxLength : null,
        disabled: this.props.disabled,
        onBlur: this.onBlur,
        onFocus: this.onFocus
      }), !this.props.staticLabel && /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: this.props.id
      }, this.props.label), /*#__PURE__*/_react["default"].createElement("div", {
        className: "invalid-feedback"
      }, this.props.invalidFeedback));
    }
  }]);

  return TextArea;
}(_react["default"].Component);

exports["default"] = TextArea;
TextArea.propTypes = {
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  invalidFeedback: _propTypes["default"].string,
  isValid: _propTypes["default"].bool,
  label: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  staticLabel: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func
};
TextArea.defaultProps = {
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {},
  autoComplete: null
};
//# sourceMappingURL=textarea.js.map